<template>
  <div id="app">
    <div class="wrapper">
      <div class="container text-left mb-5">
        <div class="header">
          <img
            class="anx-logo"
            src="@/assets/Anexia-PeeringPortal-white.svg"
          >
        </div>
        <div class="white">
          <p class="heading">
            THANK YOU!
          </p>
          <p>We have sent an email with a confirmation link to your contact email address.</p>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="anx-button"
            @click="goback"
          >
            start again >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  methods: {
    goback (){
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/less/anx-button.less";
@import "@/components/less/anx-checkbox.less";
@import "@/scss/variables.scss";

html,
body,
#app,
section.section {
  font-family: "MetaWebPro", "Avenir", Helvetica, Arial, sans-serif !important;
  background: $base-background-color 0% 0% no-repeat padding-box !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  text-align: center;
}

.white {
  background-color: #fff;
  padding: 40px;
  text-align: center;
  margin-bottom: 20px;

  > p.heading{
    color: $base-color-text-h;
    margin-bottom: 26px;
  }

  > p {
    color: $base-color-darkgrey;
    margin: 0;
  }
}

.header {
  margin-top: 60px;
  margin-bottom: 30px;
}
.anx-logo {
  height: 45px;
  left: 0px;
}
.anx-button {
  padding: 0;
}
</style>
